module.exports = __webpack_public_path__ + "static/img/5.e427b9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/5.png
// module id = ejJH
// module chunks = 0